import { useEffect, useState } from "react";

/**
 * Mantém o valor "atrasado" por `delay` ms — usado na busca da tela de
 * clientes para não disparar uma request a cada tecla digitada.
 */
const useDebouncedValue = (value, delay = 400) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(timeout);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedValue;
